export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14183.dcacdb63.jpg";